//Custom components

import { Status as ProjectStatuses } from '@stptech/shared-kit/build/constants/project';
import { cclfProjectStatus } from '@/constants/Project';

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import type { TProjectStages } from '@/types/Project.ts';
import Card from '../../UI/Card/index.tsx';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

const allProjectStatuses = Object.keys(ProjectStatuses).reduce((acc: any, next) => {
  const stageStatus = ProjectStatuses[next as TProjectStages];
  Object.keys(stageStatus).forEach((sk) => {
    acc[sk] = stageStatus[sk as keyof typeof stageStatus];
  });
  return acc;
}, {});

//appending CCLF Project statuses to avoid disruption
const updatedProjectStatuses = { ...allProjectStatuses, ...cclfProjectStatus };

export interface ProjectStatusProps {
  status: string;
  _count: number;
}

interface ProjectStatusSummaryWidgetProps {
  dashboard: DashboardType;
}

const ProjectStatusSummaryWidget = ({ dashboard }: ProjectStatusSummaryWidgetProps) => {
  const fetchProjectStatusSummaryWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECT_STATUS_SUMMARY,
  });

  const projectStatusSummaryWidgetData = fetchProjectStatusSummaryWidgetData?.data?.data;

  // const projectStatus = projectStatusSummaryWidgetData
  //   ?.map((data: ProjectStatusProps) => {
  //     switch (data?.status) {
  //       case 'REBUILD_INVENTORY': {
  //         return {
  //           name: 'Rebuild Inventory',
  //           value: data?._count,
  //           tooltipDescription:
  //             'Total amount of properties, cumulative, acquired, held by PIC or program affiliate.',
  //         };
  //       }
  //       case 'REBUILD_RFP': {
  //         return {
  //           name: 'Rebuild RFP',
  //           value: data?._count,
  //           tooltipDescription:
  //             'Number of properties currently RFP’d to developers',
  //         };
  //       }
  //       case 'DEVELOPER_AWARDED': {
  //         return {
  //           name: 'Developer Awarded',
  //           value: data?._count,
  //           tooltipDescription:
  //             'Number of properties, cumulative, awarded to developers',
  //         };
  //       }
  //       case 'DESIGN_BUILD': {
  //         return {
  //           name: 'Design-Build',
  //           value: data?._count,
  //           tooltipDescription:
  //             'Projects that are currently owned by Developer and under design/development',
  //         };
  //       }
  //       case 'FOR_SALE': {
  //         return {
  //           name: 'For Sale',
  //           value: data?._count,
  //           tooltipDescription:
  //             'Projects that developers are currently marketing for sale',
  //         };
  //       }
  //       case 'SOLD': {
  //         return {
  //           name: 'Sold',
  //           value: data?._count,
  //           tooltipDescription: 'Projects that has been sold',
  //         };
  //       }
  //       default:
  //         return false;
  //     }
  //   })
  //   .filter(
  //     (s: { name: string; value: number; tooltipDescription: string }) =>
  //       s.value !== 0
  //   );

  const projectStatus = projectStatusSummaryWidgetData?.filter((s: ProjectStatusProps) => s._count !== 0);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECT_STATUS_SUMMARY}>
      <Card title='Project Status Summary' error={fetchProjectStatusSummaryWidgetData.isError}>
        <div className='h-96 overscroll-y-auto'>
          {projectStatus?.map((s: any, index: number) => (
            <div
              key={s?.status}
              className={`flex w-full justify-between items-center py-2 px-10 ${index !== projectStatus.length - 1 ? 'border-b' : ''}`}
            >
              {/*<div className='flex items-center gap-2 text-grey-700 w-full relative'>*/}
              <span>{updatedProjectStatuses[s?.status]}</span>
              {/* <span className='relative'>
                    <QuestionMarkTooltip
                      toolTip={s?.tooltipDescription}
                      customClassName='left-5'
                    />
                  </span> */}
              {/*</div>*/}
              <span className='text-xl font-bold'>{s._count}</span>
            </div>
          ))}
        </div>
      </Card>
    </WidgetLayout>
  );
};

export default ProjectStatusSummaryWidget;
